import { render } from "./ProfileForm.vue?vue&type=template&id=410656ba&ts=true"
import script from "./ProfileForm.vue?vue&type=script&lang=ts"
export * from "./ProfileForm.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__